if(typeof(document.querySelector('[data-fixed-header]')) != 'undefined' && document.querySelector('[data-fixed-header]') != null) {

    let g_scroll = window.scrollY;

    let cookiesSection = getPreviousSibling(document.querySelector('[data-fixed-header]'), '.cookies-section');
    let cookiesSectionHeight = 0;
    let searchbarSectionHeight = 0;
    let headerPositionTop = 0;
    let headerHeight = document.querySelector('[data-fixed-header]').offsetHeight;

    console.log();

    enableFixedHeader();
    setTimeout(function () {
        enableFixedHeader();
    }, 100);

    // Update header on resize
    window.addEventListener('resize', function (event) {
        enableFixedHeader();
    });

    // Update header on scroll
    window.addEventListener('scroll', function (event) {
        enableFixedHeader();
    });

    // Set margin/top and fixed classes
    function enableFixedHeader() {
        g_scroll = window.scrollY;
        headerHeight = document.querySelector('[data-fixed-header]').offsetHeight;

        // Get `cookies-section` height if it exists
        if (cookiesSection) {
            cookiesSectionHeight = cookiesSection.offsetHeight;
            headerPositionTop = cookiesSectionHeight + searchbarSectionHeight;
        } else {
            headerPositionTop = searchbarSectionHeight;
        }

        // Set margin-top on next element
        getNextSibling(document.querySelector('[data-fixed-header]')).style.marginTop = headerHeight + 'px';
        document.querySelector('[data-fixed-header]').style.top = headerPositionTop + 'px';

        // If scrolled past `cookie-section`
        if (g_scroll > cookiesSectionHeight) {

            // Add `fixed` class on `header-section`
            headerPositionTop = searchbarSectionHeight;
            document.querySelector('[data-fixed-header]').classList.add('position-fixed');
            document.querySelector('[data-fixed-header]').style.top = headerPositionTop + 'px';

            // When not scrolled past `cookie-section`
        } else {
            console.log(searchbarSectionHeight)

            // Remove `fixed` class on `header-section`
            headerPositionTop = cookiesSectionHeight + searchbarSectionHeight;
            document.querySelector('[data-fixed-header]').classList.remove('position-fixed');
            document.querySelector('[data-fixed-header]').style.top = headerPositionTop + 'px';

        }
    }
}
